var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 33.325,
    viewBox: "0 0 46 33.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_6659",
    "data-name": "Raggruppa 6659",
    transform: "translate(-612.5 -247.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_37",
    "data-name": "Raggruppa 37",
    transform: "translate(557.482 -205.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_39",
    "data-name": "Tracciato 39",
    d: "M74.257,458.211H97.289a3.238,3.238,0,0,1,3.229,3.229v20.7a3.238,3.238,0,0,1-3.229,3.229H65.739a3.238,3.238,0,0,1-3.229-3.229V466.533",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_36",
    "data-name": "Raggruppa 36"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_21",
    "data-name": "Linea 21",
    x1: 12.306,
    y2: 12.306,
    transform: "translate(63.349 472.027)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_22",
    "data-name": "Linea 22",
    x2: 11.936,
    y2: 11.936,
    transform: "translate(87.644 472.297)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_40",
    "data-name": "Tracciato 40",
    d: "M70.439,466.533l8.68,9.083a3.4,3.4,0,0,0,4.79,0l15.739-16.108",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_41",
    "data-name": "Tracciato 41",
    d: "M73.239,453.043h-16.7a1.021,1.021,0,0,0-1.018,1.017v11.456a1.021,1.021,0,0,0,1.018,1.017h9.839l4.064,4.065v-4.065h2.8a1.021,1.021,0,0,0,1.018-1.017V454.06A1.021,1.021,0,0,0,73.239,453.043Z",
    transform: "translate(557.482 -205.043)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusta);
export default __webpack_public_path__ + "static/media/busta.174f9d5042467eee811aba7920a2334b.svg";
export { ForwardRef as ReactComponent };